import { MessageBus } from '@23degrees/shared/bus';
import { DeltaContentDirective } from '@23degrees/shared/directives/delta-content.directive';
import { ResponsiveStylePipe } from '@23degrees/shared/pipes';
import { TrackerService } from '@23degrees/shared/services/tracker/tracker.service';
import { NgStyle } from '@angular/common';
import { Component, HostListener, forwardRef, inject, signal } from '@angular/core';
import { LayoutElementComponent } from '../layout-element/layout-element.component';

@Component({
    selector: 'layout-overlay',
    templateUrl: './layout-overlay.component.html',
    styleUrls: ['./layout-overlay.component.scss'],
    imports: [NgStyle, forwardRef(() => DeltaContentDirective), ResponsiveStylePipe]
})
export class LayoutOverlayComponent extends LayoutElementComponent {


  private messageBus = inject(MessageBus);
  private trackerService = inject(TrackerService);

  public isOpen = signal(false);

  ngOnInit() {
    this.messageBus.emit('UPDATE_ACTION', ['CHART'], {
      enabled: true,
      action: { value: 'overlay', label: 'Overlay' },
    });

    this.messageBus.on('LAYOUT_EVENT', 'CHART', this.receiveLayoutEvent, this.componentDestroyed$, this.config().referenceID);
  }

  ngOnDestroy() {
    this.messageBus.emit('UPDATE_ACTION', ['CHART'], { enabled: false, action: { value: 'overlay', label: 'Overlay' } }, this.config().referenceID);
    super.ngOnDestroy();
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event) {
    if (event.key === 'Escape' && this.isOpen()) {
      this.isOpen.set(false)
    }
  }

  private receiveLayoutEvent = (msg) => {
    const { type, action } = msg;
    if (action === 'overlay') {
      if (this.content().type === 'dash') return;

      if (!this.isOpen() && action) {
        this.trackerService.postClickAction(`button_${action}`, this.content().slug);
      }

      this.isOpen.update(state => !state);
    }
  };
}
